const { isEmpty, validateType, valueAsObject } = require('../helpers/index');
const { selectImageSchema } = require('../schemas');

/**
 * validate fieldValue exists
 * @param {String} fieldValue
 * @param {object} validation
 * @param {*} validation.value if the field is mandatory
 * @param {string} validation.message message of error
 * @returns {(string | undefined)} `validation.message` or `undefined`
 */
const mandatory = (fieldValue, validation) => {
  const { value, message } = validation;
  return isEmpty(fieldValue) && value ? message : undefined;
};

const isValidType = (fieldValue, validation) => {
  const { value, message } = validation;
  return undefined;
  // const currentValue = valueAsObject(fieldValue);
  // return value && !isEmpty(currentValue) && !validateType(currentValue, selectImageSchema)
  //   ? message
  //   : undefined;
};

module.exports = {
  isValidType,
  mandatory,
};
